import { Component} from '@angular/core';
import { PrivacyBaseComponent } from '@src/base-components/privacy/privacy-base.component';
import { ConfigService } from '@src/services/layout/config.service';

@Component({
    selector: 'app-page-my-privacy',
    templateUrl: './myprivacy.component.html',
    styleUrls: ['./myprivacy.component.scss']
})
export class MyPrivacyComponent extends  PrivacyBaseComponent{
    constructor(configService: ConfigService) {
        const params = {
            appName: 'OWA',
            companyName: 'Oris',
            products: 'watches',
            ContactEmail : 'owa@oris.ch'
        };
        const logoUrl = '';
        super(params, logoUrl, configService);
    }
}